export enum StartedFrom {
    SEARCH_APP = 'search-app',
    PRODUCTS = 'products',
    YARU = 'yaru_morda_touch',
    YARU_PRODUCTS = 'zero_goods',
}

export interface MetaState {
    startedFrom: StartedFrom | null | undefined;
}
